
<div class="container mt-5 mis-dashboard">
  <div class="row " >
    <div class="row mis-dashboard">
      <!*--------------------------------------------- OCCUPANCY TABLE--------------------------------------------->
      <!*--------------------------------------------- OCCUPANCY TABLE--------------------------------------------->

      <!*--------------------------------------------- Allocation Details--------------------------------------------->

      <!--<prettyjson [obj]="dataSource.data"></prettyjson>-->
      <div class="col-md-12 col-sm-12 mb-4 card">
        <h3 class="text-center rounded text-black mt-3">Transport Details</h3>
        <div *ngIf="!dataTableLoaded" class="body d-flex justify-content-center">
          <mat-spinner></mat-spinner>
        </div>
        <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">

          <!-- Vehicle Number -->
          <ng-container matColumnDef="vehicleNumber">
            <th mat-header-cell *matHeaderCellDef>Vehicle Number </th>
            <td mat-cell *matCellDef="let v"> {{v?.vehicleNumber}} </td>
          </ng-container>

          <!-- Vehicle Name -->
          <ng-container matColumnDef="vehicleName">
            <th mat-header-cell *matHeaderCellDef> Name </th>
            <td mat-cell *matCellDef="let v"> {{v?.vehicleName}} </td>
          </ng-container>

          <!-- Brand -->
          <ng-container matColumnDef="vehicleBrand">
            <th mat-header-cell *matHeaderCellDef> Brand </th>
            <td mat-cell *matCellDef="let v"> {{v?.vehicleBrand}} </td>
          </ng-container>

          <!-- Fuel -->
          <ng-container matColumnDef="fuelUsed">
            <th mat-header-cell *matHeaderCellDef> Fuel </th>
            <td mat-cell *matCellDef="let v"> {{v?.fuelUsed}} </td>
          </ng-container>


<!--          &lt;!&ndash; Status &ndash;&gt;-->
<!--          <ng-container matColumnDef="status">-->
<!--            <th mat-header-cell *matHeaderCellDef> Status </th>-->
<!--            <td mat-cell *matCellDef="let v"> {{v?.status}} </td>-->
<!--          </ng-container>-->
          <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef>Trip Status</th>
            <td mat-cell *matCellDef="let element">
              <!-- If status is "Pending", show a clickable button -->
              <button type="button" *ngIf="element.status === 'off_trip'" style="color: #e30c25;border: 1px solid; border-radius: 5px" matTooltip="Click here to change status">
                OFF_TRIP
              </button>
              <!-- If status is "Closed", show a non-clickable button -->
              <button type="button" *ngIf="element.status === 'on_trip'" (click)="openConfirmationDialog(element)" style="color: #1b4709;border: 1px solid; border-radius: 5px" matTooltip="Click here to change status">
                ON_TRIP
              </button>
              <button type="button" *ngIf="element.status === 'round_trip'" (click)="openConfirmationDialog(element)" style="color: #075af4;border: 1px solid; border-radius: 5px" matTooltip="Click here to change status">
                ROUND_TRIP
              </button>
            </td>
          </ng-container>
          <ng-container matColumnDef="location">
            <th mat-header-cell *matHeaderCellDef> Location </th>
            <td mat-cell *matCellDef="let v"> {{v?.location}} </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>

      </div>

      <hr>

      <!*--------------------------------------------- Selection --------------------------------------------->
      <div class=" d-flex justify-content-center  ">

        <mat-form-field appearance="outline" class="col-md-2">
          <mat-label>From</mat-label>
          <input matInput [matDatepicker]="start" [min]="startRange" [(ngModel)]="mStartDate">
          <mat-hint>DD/MM/YYYY</mat-hint>
          <mat-datepicker-toggle  matSuffix [for]="start" ></mat-datepicker-toggle>
          <mat-datepicker #start></mat-datepicker>
        </mat-form-field> &nbsp;&nbsp;&nbsp;

        <mat-form-field appearance="outline" class="col-md-2">
          <mat-label>To</mat-label>
          <input matInput [matDatepicker]="end" [min]="startRange" [(ngModel)]="mEndDate">
          <mat-hint>DD/MM/YYYY</mat-hint>
          <mat-datepicker-toggle matSuffix [for]="end"></mat-datepicker-toggle>
          <mat-datepicker #end></mat-datepicker>
        </mat-form-field>&nbsp;&nbsp;&nbsp;

        <mat-form-field appearance="outline" class="ms-2">
          <mat-label>Select Centre</mat-label>
          <mat-select [formControl]="selectCentre" (selectionChange)="onCentreSelection($event)"
          >
            <mat-option *ngFor="let c of centreSelectionArray"
                        [value]=c.centreCode>{{c.centreName}}</mat-option>
          </mat-select>
        </mat-form-field>
        &nbsp;&nbsp; &nbsp;&nbsp;
        <button (click)="search()" color="accent" mat-mini-fab><mat-icon>search</mat-icon></button> &nbsp; &nbsp;
        <button mat-mini-fab color="warn" (click)="resetDate()"><mat-icon>clear</mat-icon></button>
      </div>
      <!*--------------------------------------------- CARDS --------------------------------------------->
      <div class="row">

        <!-- Drivers -->
        <div class="col-lg-3 col-sm-6">
          <div class="info-box7 l-bg-orange order-info-box7 scale-on-hover">
            <div class="info-box7-block">
              <h4 class="m-b-20">Drivers</h4>
              <h2 class="text-end">
                <i class="fas fa-user float-start"></i>
                <span>{{ totalDrivers }}</span>
              </h2>
              <div class="m-b-0 d-flex justify-content-between">
                <div>Active <br>{{ activeDrivers }}</div>
                <div>Inactive<br>{{ expiringLicenses }}</div>
              </div>
            </div>
          </div>
        </div>


        <!-- Trips -->
        <div class="col-lg-3 col-sm-6">
          <div class="info-box7 l-bg-card3 order-info-box7 scale-on-hover">
            <div class="info-box7-block">
              <h4 class="m-b-20">Trips</h4>
              <h2 class="text-end"><i class="fas fa-route float-start"></i><span>{{totalTrips}}</span></h2>
              <div class="m-b-0 d-flex justify-content-between">
<!--                <div>Ongoing <br>{{currentTrips}}</div>-->
                <div>With Child <br>{{tripsWithChild}}</div>
                <div>Without Child <br>{{tripsWithoutChild}}</div>
              </div>
            </div>
          </div>
        </div>

        <!-- Vehicles -->
        <div class="col-lg-3 col-sm-6">
          <div class="info-box7 l-bg-card1 order-info-box7 scale-on-hover">
            <div class="info-box7-block">
              <h4 class="m-b-20">Vehicles</h4>
              <h2 class="text-end">
                <i class="fas fa-bus float-start"></i>
                <span>{{totalVehicles}}</span>
              </h2>
              <div class="m-b-0 d-flex justify-content-between">
                <div>On Trip <br>{{vehiclesOnTrip}}</div>
                <div>Off Trip <br>{{vehiclesOffTrip}}</div>
<!--                <div>Most Used <br>{{mostUsedVehicle}}</div>-->
              </div>
            </div>
          </div>
        </div>


        <!-- Fuel & KM -->
        <div class="col-lg-3 col-sm-6">
          <div class="info-box7 l-bg-card2 order-info-box7 scale-on-hover">
            <div class="info-box7-block">
              <h4 class="m-b-20">Fuel & KM</h4>
              <h2 class="text-end"><i class="fas fa-gas-pump float-start"></i><span>{{totalFuel}} L</span></h2>
              <div class="m-b-0 d-flex justify-content-between">
                <div>Total KM <br>{{totalKm}}</div>
                <div>Top Fuel Vehicle <br>{{fuelHungryVehicle}}</div>
              </div>
            </div>
          </div>
        </div>

      </div>
      <ng-container  >
        <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
          <div class="card">
            <div class="header">
              <h2>Trips Per Driver</h2>
            </div>
            <div class="body">
            <canvas baseChart
                    [data]="driverChartData"
                    [options]="chartOptions"
                    chartType="bar">
            </canvas>
            </div>
          </div>
          <div class="card">
            <div class="header">
              <h2><b>Recent Drivers</b></h2>
            </div>

            <div class="tableBody">
              <div class="table-responsive">
                <table class="table table-hover dashboard-task-infos">
                  <thead>
                  <tr>
                    <th>Name</th>
                    <th>Phone</th>
                    <th>Date Of Joining</th>
                  </tr>
                  </thead>
                  <tbody>
                  <ng-container *ngFor="let driver of driversList | slice:0:5">
                    <tr>
                      <td>{{driver.firstName}} {{driver.middleName}} {{driver.lastName}}</td>
                      <td><a href="tel:{{driver.phone}}">{{driver.phone}}</a></td>
                      <td>{{driver.dateOfJoining?.toDate() | date:'dd/MM/yyyy'}}</td>
                    </tr>
                  </ng-container>
                  </tbody>
                </table>
              </div>
            </div>
          </div>


        </div>

      </ng-container>
      <ng-container>
        <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">

          <!-- Trips Per Vehicle Chart -->
          <div class="card">
            <div class="header">
              <h2>Trips Per Vehicle</h2>
            </div>
            <div class="body">
              <canvas baseChart
                      [data]="vehicleChartData"
                      [options]="chartOptions"
                      chartType="bar">
              </canvas>
            </div>
          </div>

          <!-- Recent Trip Log Table -->
          <div class="card">
            <div class="header">
              <h2><b>Recent Trip Log</b></h2>
            </div>
            <div class="tableBody">
              <div class="table-responsive">
                <table class="table table-hover dashboard-task-infos">
                  <thead>
                  <tr>
                    <th>Driver</th>
                    <th>Vehicle</th>
                    <th>Distance (Km)</th>
                    <th>Started</th>
                    <th>Ended</th>
                    <th>Status</th>
                  </tr>
                  </thead>
                  <tbody>
                  <ng-container *ngFor="let trip of tripsList | slice:0:5">
                    <tr>
                      <td>{{trip.vehicle_info?.driverName}}</td>
                      <td>{{trip.vehicle_info?.vehicleNumber}}</td>
                      <td>{{trip.tripDistanceKm | number:'1.2-2'}}</td>
                      <td>{{trip.trip_started_at?.toDate() | date:'dd/MM/yyyy HH:mm'}}</td>
                      <td>{{trip.trip_ended_at?.toDate() | date:'dd/MM/yyyy HH:mm'}}</td>
                      <td>{{trip.status}}</td>
                    </tr>
                  </ng-container>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <!-- Optional recent admissions component -->

        </div>
      </ng-container>

    </div>

  </div>

</div>
